// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IAccountCategoryDto,
  IAccountCloseMessage,
  IAccountClosureAmountsDto,
  IAccountDto,
  IAccountNumberDto,
  IAccountTypeDto,
  IAccountVerificationStatusResponseDto,
  IBalanceAdjustmentRequestDto,
  IBalanceAdjustmentTrackingResponseDto,
  ICalculateTotalBalanceRequestDto,
  ICalculateTotalBalanceResponseDto,
  ICalculationAccountAmountRequestDto,
  ICalculationAccountAmountResponseDto,
  ICreateEncryptedExternalBankAccountDto,
  ICreateTransactionWorkflowDto,
  ICustomPageAccountDto,
  ICustomPageEncryptedAccountDto,
  IEncryptedAccountDto,
  IErrorDto,
  IFeeReversalCreateDto,
  IFeeTransferCreateDto,
  IGenericErrorDto,
  IManualTransactionResponseDto,
  IPageTransactionDto,
  IPlanOmniBalanceHistoryDto,
  IPublicKeyDto,
  IUpdateEncryptedExternalBankAccountDto,
} from '../models/index';
import {
    IAccountCategoryDtoFromJSON,
    IAccountCategoryDtoToJSON,
    IAccountCloseMessageFromJSON,
    IAccountCloseMessageToJSON,
    IAccountClosureAmountsDtoFromJSON,
    IAccountClosureAmountsDtoToJSON,
    IAccountDtoFromJSON,
    IAccountDtoToJSON,
    IAccountNumberDtoFromJSON,
    IAccountNumberDtoToJSON,
    IAccountTypeDtoFromJSON,
    IAccountTypeDtoToJSON,
    IAccountVerificationStatusResponseDtoFromJSON,
    IAccountVerificationStatusResponseDtoToJSON,
    IBalanceAdjustmentRequestDtoFromJSON,
    IBalanceAdjustmentRequestDtoToJSON,
    IBalanceAdjustmentTrackingResponseDtoFromJSON,
    IBalanceAdjustmentTrackingResponseDtoToJSON,
    ICalculateTotalBalanceRequestDtoFromJSON,
    ICalculateTotalBalanceRequestDtoToJSON,
    ICalculateTotalBalanceResponseDtoFromJSON,
    ICalculateTotalBalanceResponseDtoToJSON,
    ICalculationAccountAmountRequestDtoFromJSON,
    ICalculationAccountAmountRequestDtoToJSON,
    ICalculationAccountAmountResponseDtoFromJSON,
    ICalculationAccountAmountResponseDtoToJSON,
    ICreateEncryptedExternalBankAccountDtoFromJSON,
    ICreateEncryptedExternalBankAccountDtoToJSON,
    ICreateTransactionWorkflowDtoFromJSON,
    ICreateTransactionWorkflowDtoToJSON,
    ICustomPageAccountDtoFromJSON,
    ICustomPageAccountDtoToJSON,
    ICustomPageEncryptedAccountDtoFromJSON,
    ICustomPageEncryptedAccountDtoToJSON,
    IEncryptedAccountDtoFromJSON,
    IEncryptedAccountDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IFeeReversalCreateDtoFromJSON,
    IFeeReversalCreateDtoToJSON,
    IFeeTransferCreateDtoFromJSON,
    IFeeTransferCreateDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    IManualTransactionResponseDtoFromJSON,
    IManualTransactionResponseDtoToJSON,
    IPageTransactionDtoFromJSON,
    IPageTransactionDtoToJSON,
    IPlanOmniBalanceHistoryDtoFromJSON,
    IPlanOmniBalanceHistoryDtoToJSON,
    IPublicKeyDtoFromJSON,
    IPublicKeyDtoToJSON,
    IUpdateEncryptedExternalBankAccountDtoFromJSON,
    IUpdateEncryptedExternalBankAccountDtoToJSON,
} from '../models/index';

export interface CalculatePosingAmountsRequest {
    iCalculationAccountAmountRequestDto: ICalculationAccountAmountRequestDto;
}

export interface CalculateTotalBalanceRequest {
    iCalculateTotalBalanceRequestDto: ICalculateTotalBalanceRequestDto;
}

export interface CloseAccountRequest {
    iAccountCloseMessage: IAccountCloseMessage;
}

export interface CreateOrGetAccountRequest {
    iCreateEncryptedExternalBankAccountDto: ICreateEncryptedExternalBankAccountDto;
}

export interface CreateTransactionManuallyRequest {
    iCreateTransactionWorkflowDto: ICreateTransactionWorkflowDto;
}

export interface FeeReversalRequest {
    iFeeReversalCreateDto: IFeeReversalCreateDto;
}

export interface FeeTransferRequest {
    iFeeTransferCreateDto: IFeeTransferCreateDto;
}

export interface FindTransactionsRequest {
    accountId: number;
    types?: Set<FindTransactionsTypesEnum>;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetAccountRequest {
    id: number;
}

export interface GetAccountActivityTransactionTypesRequest {
    accountId: number;
}

export interface GetAccountBatchRequest {
    ids: Set<number>;
}

export interface GetAccountClosureAmountsRequest {
    accountId: number;
}

export interface GetAccountsRequest {
    employeeId?: number;
    type?: GetAccountsTypeEnum;
    statusType?: GetAccountsStatusTypeEnum;
    externalIdentifier?: string;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetAccountsWithVerificationStatusRequest {
    employeeId: number;
    accountType: GetAccountsWithVerificationStatusAccountTypeEnum;
    accountStatusTypes: Set<GetAccountsWithVerificationStatusAccountStatusTypesEnum>;
}

export interface GetDecryptedAccountNumberRequest {
    body: string;
}

export interface GetDecryptedAccountNumberByAccountIdRequest {
    accountId: number;
}

export interface GetExternalAccountsByOrganizationRequest {
    organizationId: number;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetHsaAccountNumberRequest {
    accountId: number;
}

export interface GetHsaAccountsByEmployeeIdsRequest {
    employeeIds: Set<number>;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetHsaAccountsBySearchValueRequest {
    searchValue?: string;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetInternalAccountNumberRequest {
    accountId: number;
    accountType: GetInternalAccountNumberAccountTypeEnum;
}

export interface GetPlanOmniBalanceHistory1Request {
    accountId: number;
    startDay: Date;
    endDay: Date;
}

export interface TriggerBalanceAdjustmentWorkflow1Request {
    iBalanceAdjustmentRequestDto: IBalanceAdjustmentRequestDto;
}

export interface UpdateAccountRequest {
    id: number;
    iUpdateEncryptedExternalBankAccountDto: IUpdateEncryptedExternalBankAccountDto;
}

/**
 * BankingServiceServiceApi - interface
 * 
 * @export
 * @interface BankingServiceServiceApiInterface
 */
export interface BankingServiceServiceApiInterface {
    /**
     * 
     * @summary calculate posting amount per each account for specific types
     * @param {ICalculationAccountAmountRequestDto} iCalculationAccountAmountRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    calculatePosingAmountsRaw(requestParameters: CalculatePosingAmountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICalculationAccountAmountResponseDto>>>;

    /**
     * calculate posting amount per each account for specific types
     */
    calculatePosingAmounts(requestParameters: CalculatePosingAmountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICalculationAccountAmountResponseDto>>;

    /**
     * 
     * @summary Calculate total available balance for the given accounts
     * @param {ICalculateTotalBalanceRequestDto} iCalculateTotalBalanceRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    calculateTotalBalanceRaw(requestParameters: CalculateTotalBalanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICalculateTotalBalanceResponseDto>>;

    /**
     * Calculate total available balance for the given accounts
     */
    calculateTotalBalance(requestParameters: CalculateTotalBalanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICalculateTotalBalanceResponseDto>;

    /**
     * 
     * @summary Close account
     * @param {IAccountCloseMessage} iAccountCloseMessage 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    closeAccountRaw(requestParameters: CloseAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Close account
     */
    closeAccount(requestParameters: CloseAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Create or get external account
     * @param {ICreateEncryptedExternalBankAccountDto} iCreateEncryptedExternalBankAccountDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    createOrGetAccountRaw(requestParameters: CreateOrGetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEncryptedAccountDto>>;

    /**
     * Create or get external account
     */
    createOrGetAccount(requestParameters: CreateOrGetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEncryptedAccountDto>;

    /**
     * 
     * @summary Manual creation of a transaction. Requires FIN_OPS or SUPER_USER role.
     * @param {ICreateTransactionWorkflowDto} iCreateTransactionWorkflowDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    createTransactionManuallyRaw(requestParameters: CreateTransactionManuallyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IManualTransactionResponseDto>>;

    /**
     * Manual creation of a transaction. Requires FIN_OPS or SUPER_USER role.
     */
    createTransactionManually(requestParameters: CreateTransactionManuallyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IManualTransactionResponseDto>;

    /**
     * 
     * @summary Reverse fee
     * @param {IFeeReversalCreateDto} iFeeReversalCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    feeReversalRaw(requestParameters: FeeReversalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Reverse fee
     */
    feeReversal(requestParameters: FeeReversalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Transfer fee
     * @param {IFeeTransferCreateDto} iFeeTransferCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    feeTransferRaw(requestParameters: FeeTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Transfer fee
     */
    feeTransfer(requestParameters: FeeTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Find transactions by types and account ID
     * @param {number} accountId 
     * @param {Set<'NOTIONAL_FUND' | 'REPLENISHMENT_PAYMENT' | 'REPLENISHMENT' | 'NOTIONAL_PAYROLL' | 'CARD_SETTLEMENT' | 'PAY_CLAIM' | 'CHECK_CLEARED' | 'CARD_PROCESSOR_PAYMENT' | 'RECORD_KEEPING_PAYROLL' | 'CONTRIBUTION_PAYMENT' | 'PAYROLL' | 'EMPLOYER_PAYMENT' | 'PAYMENT' | 'INTEREST' | 'FEE' | 'TRANSFER_OF_ASSETS' | 'INVESTMENT' | 'ACH_CLEARED' | 'DEBIT_CLEARED' | 'VENMO_CLEARED' | 'PAYPAL_CLEARED' | 'ADJUSTMENT' | 'INTEREST_PAYMENT' | 'BUY_INVESTMENT' | 'SELL_INVESTMENT' | 'BUY_INVESTMENT_CLEARED' | 'SELL_INVESTMENT_CLEARED' | 'CLAIM_REPAYMENT' | 'LOCKBOX_PAYMENT' | 'PAYMENT_CARD_RETURN' | 'ROLLOVER' | 'DIGITAL_SETTLEMENT' | 'DEBIT_VENMO_PAYPAL_REJECTED' | 'RETURN_REPLENISHMENT_PAYMENT' | 'RECORD_KEEPING' | 'CONTRIBUTION_PAID' | 'PREFUND_REPLENISHMENT' | 'INTERNAL_TRANSFER_OF_ASSETS' | 'HSA_INCOMING_CONTRIBUTION' | 'HSA_ROLLOVER' | 'ORPHAN_EE_FEE' | 'ORPHAN_EE_FEE_PAYMENT' | 'ADMIN_FEE' | 'ADMIN_FEE_PAYMENT' | 'REPLENISHMENT_REVERSE' | 'ACH_REJECTED' | 'RETURN_CONTRIBUTION_PAYMENT' | 'HSA_INCOMING_CONTRIBUTION_REVERSE' | 'HSA_ROLLOVER_REVERSE' | 'INVESTMENT_FEES' | 'REPLENISHMENT_FUNDING_REVERSE' | 'RETURN_REPLENISHMENT_FUNDING_PAYMENT' | 'CLAIM_TRANSFER' | 'CLAIM_TRANSFER_INTERNAL' | 'PAYROLL_REVERSE' | 'CONTRIBUTION_PAID_REVERSE' | 'CONTRIBUTION_REVERSE_PAYMENT' | 'PREFUND_REPLENISHMENT_RETURN' | 'FINAL_PREFUND_REPLENISHMENT_RETURN' | 'PREFUND_PAYMENT' | 'PREFUND_INTER' | 'RETURN_PREFUND_FUNDING_PAYMENT' | 'PREFUND_FINAL' | 'PREFUND_FUNDING_REVERSE' | 'RETURN_LOCKBOX' | 'INBOUND_CHECK_CLEARED' | 'LOCKBOX_INCOMING' | 'INBOUND_TRANSFER_OF_ASSETS' | 'OUTBOUND_TRANSFER_OF_ASSETS' | 'OUTBOUND_CHECK_CLEARED' | 'CLAIM_OFFSET' | 'WRITE_OFF' | 'FORFEITURE' | 'PUSH_REPLENISHMENT_PAYMENT' | 'PUSH_PREFUND_PAYMENT' | 'PUSH_CONTRIBUTION_PAYMENT' | 'PAYMENT_EE_FEE' | 'ACCOUNT_MAINTENANCE_EE_FEE' | 'PAPER_STATEMENT_EE_FEE' | 'EE_FEES_BULK_PAYMENT' | 'OTHER_ROOT_INTERNAL_TRANSFER_OF_ASSETS' | 'FEE_TRANSFER_INTERNAL' | 'FEE_TRANSFER' | 'CLAIM_REJECTION' | 'ACH_CLAIM_REPAYMENT' | 'ACH_CLAIM_REPAYMENT_REJECTED' | 'CLAIM_REPAYMENT_REJECTION' | 'CLAIM_REPAYMENT_TRANSFER_INTERNAL' | 'CLAIM_REPAYMENT_TRANSFER' | 'LOCKBOX_CHECK_CLEARED' | 'LOCKBOX_CLAIM_REPAYMENT' | 'NOTIONAL_CONTRIBUTION_PAID' | 'PREFUND_RETURN_PAYMENT_REVERSE' | 'CLAIM_BALANCE_ADJUSTMENT' | 'NOTIONAL_CONTRIBUTION_PAID_REVERSE' | 'ROLLOVER_BALANCE_ADJUSTMENT' | 'EOY_PLAN_FUNDS_INTERNAL_RETURN' | 'PUSH_RETURN_PAYMENT' | 'HSA_INCOMING_CONTRIBUTION_PAYMENT' | 'NOTIONAL_PAYROLL_REVERSE' | 'EOY_PLAN_FUNDS_INTERNAL_RETURN_PAYMENT' | 'EOY_PLAN_FUNDS_EXTERNAL_RETURN' | 'EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT' | 'EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT_REVERSE' | 'EOY_PLAN_SHORTAGE_COLLECTION' | 'EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT' | 'EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT_REVERSE' | 'EOY_PLAN_SHORTAGE_COLLECTION_PUSH_PAYMENT' | 'PUSH_UNKNOWN_PAYMENT' | 'UNMATCHED_PUSH_KEEPING' | 'PUSH_INVOICE_PAYMENT' | 'UNMATCHED_PUSH_RETURN' | 'CLAIM_BALANCE_ADJUSTMENT_EXTERNAL' | 'ROLLOVER_BALANCE_ADJUSTMENT_CROSS_OMNIBUS' | 'ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL' | 'BULK_BALANCE_ADJUSTMENT' | 'BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT' | 'BULK_BALANCE_ADJUSTMENT_PUSH_PAYMENT' | 'BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT_REVERSE' | 'BULK_BALANCE_ADJUSTMENT_REVERSE' | 'CLAIM_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE' | 'ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE' | 'BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT' | 'BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT_REVERSE'>} [types] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    findTransactionsRaw(requestParameters: FindTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageTransactionDto>>;

    /**
     * Find transactions by types and account ID
     */
    findTransactions(requestParameters: FindTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageTransactionDto>;

    /**
     * 
     * @summary Get existing account by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    getAccountRaw(requestParameters: GetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEncryptedAccountDto>>;

    /**
     * Get existing account by id
     */
    getAccount(requestParameters: GetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEncryptedAccountDto>;

    /**
     * 
     * @summary Get account activities transaction types by account
     * @param {number} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    getAccountActivityTransactionTypesRaw(requestParameters: GetAccountActivityTransactionTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Set<string>>>;

    /**
     * Get account activities transaction types by account
     */
    getAccountActivityTransactionTypes(requestParameters: GetAccountActivityTransactionTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Set<string>>;

    /**
     * 
     * @summary Get existing accounts by ids
     * @param {Set<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    getAccountBatchRaw(requestParameters: GetAccountBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEncryptedAccountDto>>>;

    /**
     * Get existing accounts by ids
     */
    getAccountBatch(requestParameters: GetAccountBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEncryptedAccountDto>>;

    /**
     * 
     * @summary Get all existing account categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    getAccountCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAccountCategoryDto>>>;

    /**
     * Get all existing account categories
     */
    getAccountCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAccountCategoryDto>>;

    /**
     * 
     * @summary Get account closure amounts
     * @param {number} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    getAccountClosureAmountsRaw(requestParameters: GetAccountClosureAmountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAccountClosureAmountsDto>>;

    /**
     * Get account closure amounts
     */
    getAccountClosureAmounts(requestParameters: GetAccountClosureAmountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAccountClosureAmountsDto>;

    /**
     * 
     * @summary Get all existing AccountTypes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    getAccountTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAccountTypeDto>>>;

    /**
     * Get all existing AccountTypes
     */
    getAccountTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAccountTypeDto>>;

    /**
     * 
     * @summary Get all existing accounts
     * @param {number} [employeeId] 
     * @param {'HSA' | 'HCFSA' | 'HRA' | 'DCAP' | 'EXTERNAL' | 'CLEARING' | 'SUB_ACCOUNT' | 'OMNIBUS' | 'PARKING' | 'TRANSIT' | 'ADOPTION' | 'SPECIALTY' | 'LIFESTYLE' | 'WAGEPARITY' | 'PLAN_OMNIBUS' | 'NOTIONAL_PAYROLL' | 'NOTIONAL_FUNDING' | 'TRAVEL'} [type] 
     * @param {'OPEN' | 'CLOSED' | 'PENDING_CLOSED' | 'FROZEN' | 'PENDING'} [statusType] 
     * @param {string} [externalIdentifier] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported. Example: created_at,desc; id; created_at; type_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    getAccountsRaw(requestParameters: GetAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageEncryptedAccountDto>>;

    /**
     * Get all existing accounts
     */
    getAccounts(requestParameters: GetAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageEncryptedAccountDto>;

    /**
     * 
     * @summary Get all accounts with verification status by search params
     * @param {number} employeeId 
     * @param {'HSA' | 'HCFSA' | 'HRA' | 'DCAP' | 'EXTERNAL' | 'CLEARING' | 'SUB_ACCOUNT' | 'OMNIBUS' | 'PARKING' | 'TRANSIT' | 'ADOPTION' | 'SPECIALTY' | 'LIFESTYLE' | 'WAGEPARITY' | 'PLAN_OMNIBUS' | 'NOTIONAL_PAYROLL' | 'NOTIONAL_FUNDING' | 'TRAVEL'} accountType 
     * @param {Set<'OPEN' | 'CLOSED' | 'PENDING_CLOSED' | 'FROZEN' | 'PENDING'>} accountStatusTypes 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    getAccountsWithVerificationStatusRaw(requestParameters: GetAccountsWithVerificationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAccountVerificationStatusResponseDto>>>;

    /**
     * Get all accounts with verification status by search params
     */
    getAccountsWithVerificationStatus(requestParameters: GetAccountsWithVerificationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAccountVerificationStatusResponseDto>>;

    /**
     * 
     * @summary Decrypt account number last 4 digits
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    getDecryptedAccountNumberRaw(requestParameters: GetDecryptedAccountNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Decrypt account number last 4 digits
     */
    getDecryptedAccountNumber(requestParameters: GetDecryptedAccountNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * 
     * @summary Get decrypted account number
     * @param {number} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    getDecryptedAccountNumberByAccountIdRaw(requestParameters: GetDecryptedAccountNumberByAccountIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Get decrypted account number
     */
    getDecryptedAccountNumberByAccountId(requestParameters: GetDecryptedAccountNumberByAccountIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * 
     * @summary Get all existing EXTERNAL accounts by organizationId
     * @param {number} organizationId 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    getExternalAccountsByOrganizationRaw(requestParameters: GetExternalAccountsByOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageEncryptedAccountDto>>;

    /**
     * Get all existing EXTERNAL accounts by organizationId
     */
    getExternalAccountsByOrganization(requestParameters: GetExternalAccountsByOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageEncryptedAccountDto>;

    /**
     * 
     * @summary Get HSA account number & routing transit number by account_id
     * @param {number} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    getHsaAccountNumberRaw(requestParameters: GetHsaAccountNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAccountNumberDto>>;

    /**
     * Get HSA account number & routing transit number by account_id
     */
    getHsaAccountNumber(requestParameters: GetHsaAccountNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAccountNumberDto>;

    /**
     * 
     * @summary Get accounts by employee
     * @param {Set<number>} employeeIds 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported. Example: created_at,desc; id; created_at; type_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    getHsaAccountsByEmployeeIdsRaw(requestParameters: GetHsaAccountsByEmployeeIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAccountDto>>>;

    /**
     * Get accounts by employee
     */
    getHsaAccountsByEmployeeIds(requestParameters: GetHsaAccountsByEmployeeIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAccountDto>>;

    /**
     * 
     * @summary Find HSA accounts that contains search value in the fields: account number
     * @param {string} [searchValue] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported. Example: created_at,desc; id; created_at; type_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    getHsaAccountsBySearchValueRaw(requestParameters: GetHsaAccountsBySearchValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageAccountDto>>;

    /**
     * Find HSA accounts that contains search value in the fields: account number
     */
    getHsaAccountsBySearchValue(requestParameters: GetHsaAccountsBySearchValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageAccountDto>;

    /**
     * 
     * @summary Get internal account number by account_id
     * @param {number} accountId 
     * @param {'HSA' | 'HCFSA' | 'HRA' | 'DCAP' | 'EXTERNAL' | 'CLEARING' | 'SUB_ACCOUNT' | 'OMNIBUS' | 'PARKING' | 'TRANSIT' | 'ADOPTION' | 'SPECIALTY' | 'LIFESTYLE' | 'WAGEPARITY' | 'PLAN_OMNIBUS' | 'NOTIONAL_PAYROLL' | 'NOTIONAL_FUNDING' | 'TRAVEL'} accountType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    getInternalAccountNumberRaw(requestParameters: GetInternalAccountNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Get internal account number by account_id
     */
    getInternalAccountNumber(requestParameters: GetInternalAccountNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get plan Omni balance history for account by date range
     * @param {number} accountId 
     * @param {Date} startDay 
     * @param {Date} endDay 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    getPlanOmniBalanceHistory1Raw(requestParameters: GetPlanOmniBalanceHistory1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanOmniBalanceHistoryDto>>>;

    /**
     * Get plan Omni balance history for account by date range
     */
    getPlanOmniBalanceHistory1(requestParameters: GetPlanOmniBalanceHistory1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanOmniBalanceHistoryDto>>;

    /**
     * 
     * @summary Get public key for encryption
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    getPublicKeyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPublicKeyDto>>;

    /**
     * Get public key for encryption
     */
    getPublicKey(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPublicKeyDto>;

    /**
     * 
     * @summary Trigger balance adjustment workflow
     * @param {IBalanceAdjustmentRequestDto} iBalanceAdjustmentRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    triggerBalanceAdjustmentWorkflow1Raw(requestParameters: TriggerBalanceAdjustmentWorkflow1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IBalanceAdjustmentTrackingResponseDto>>;

    /**
     * Trigger balance adjustment workflow
     */
    triggerBalanceAdjustmentWorkflow1(requestParameters: TriggerBalanceAdjustmentWorkflow1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IBalanceAdjustmentTrackingResponseDto>;

    /**
     * 
     * @summary Update account by id
     * @param {number} id 
     * @param {IUpdateEncryptedExternalBankAccountDto} iUpdateEncryptedExternalBankAccountDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingServiceServiceApiInterface
     */
    updateAccountRaw(requestParameters: UpdateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEncryptedAccountDto>>;

    /**
     * Update account by id
     */
    updateAccount(requestParameters: UpdateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEncryptedAccountDto>;

}

/**
 * 
 */
export class BankingServiceServiceApi extends runtime.BaseAPI implements BankingServiceServiceApiInterface {

    /**
     * calculate posting amount per each account for specific types
     */
    async calculatePosingAmountsRaw(requestParameters: CalculatePosingAmountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICalculationAccountAmountResponseDto>>> {
        if (requestParameters['iCalculationAccountAmountRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iCalculationAccountAmountRequestDto',
                'Required parameter "iCalculationAccountAmountRequestDto" was null or undefined when calling calculatePosingAmounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/postings/account/amount`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICalculationAccountAmountRequestDtoToJSON(requestParameters['iCalculationAccountAmountRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ICalculationAccountAmountResponseDtoFromJSON));
    }

    /**
     * calculate posting amount per each account for specific types
     */
    async calculatePosingAmounts(requestParameters: CalculatePosingAmountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICalculationAccountAmountResponseDto>> {
        const response = await this.calculatePosingAmountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Calculate total available balance for the given accounts
     */
    async calculateTotalBalanceRaw(requestParameters: CalculateTotalBalanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICalculateTotalBalanceResponseDto>> {
        if (requestParameters['iCalculateTotalBalanceRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iCalculateTotalBalanceRequestDto',
                'Required parameter "iCalculateTotalBalanceRequestDto" was null or undefined when calling calculateTotalBalance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts/calculate-total-balance`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICalculateTotalBalanceRequestDtoToJSON(requestParameters['iCalculateTotalBalanceRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICalculateTotalBalanceResponseDtoFromJSON(jsonValue));
    }

    /**
     * Calculate total available balance for the given accounts
     */
    async calculateTotalBalance(requestParameters: CalculateTotalBalanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICalculateTotalBalanceResponseDto> {
        const response = await this.calculateTotalBalanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Close account
     */
    async closeAccountRaw(requestParameters: CloseAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iAccountCloseMessage'] == null) {
            throw new runtime.RequiredError(
                'iAccountCloseMessage',
                'Required parameter "iAccountCloseMessage" was null or undefined when calling closeAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts/close`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IAccountCloseMessageToJSON(requestParameters['iAccountCloseMessage']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Close account
     */
    async closeAccount(requestParameters: CloseAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.closeAccountRaw(requestParameters, initOverrides);
    }

    /**
     * Create or get external account
     */
    async createOrGetAccountRaw(requestParameters: CreateOrGetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEncryptedAccountDto>> {
        if (requestParameters['iCreateEncryptedExternalBankAccountDto'] == null) {
            throw new runtime.RequiredError(
                'iCreateEncryptedExternalBankAccountDto',
                'Required parameter "iCreateEncryptedExternalBankAccountDto" was null or undefined when calling createOrGetAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICreateEncryptedExternalBankAccountDtoToJSON(requestParameters['iCreateEncryptedExternalBankAccountDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEncryptedAccountDtoFromJSON(jsonValue));
    }

    /**
     * Create or get external account
     */
    async createOrGetAccount(requestParameters: CreateOrGetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEncryptedAccountDto> {
        const response = await this.createOrGetAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Manual creation of a transaction. Requires FIN_OPS or SUPER_USER role.
     */
    async createTransactionManuallyRaw(requestParameters: CreateTransactionManuallyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IManualTransactionResponseDto>> {
        if (requestParameters['iCreateTransactionWorkflowDto'] == null) {
            throw new runtime.RequiredError(
                'iCreateTransactionWorkflowDto',
                'Required parameter "iCreateTransactionWorkflowDto" was null or undefined when calling createTransactionManually().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/transactions/manual-transactions`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICreateTransactionWorkflowDtoToJSON(requestParameters['iCreateTransactionWorkflowDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IManualTransactionResponseDtoFromJSON(jsonValue));
    }

    /**
     * Manual creation of a transaction. Requires FIN_OPS or SUPER_USER role.
     */
    async createTransactionManually(requestParameters: CreateTransactionManuallyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IManualTransactionResponseDto> {
        const response = await this.createTransactionManuallyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reverse fee
     */
    async feeReversalRaw(requestParameters: FeeReversalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iFeeReversalCreateDto'] == null) {
            throw new runtime.RequiredError(
                'iFeeReversalCreateDto',
                'Required parameter "iFeeReversalCreateDto" was null or undefined when calling feeReversal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/fee/reversal`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IFeeReversalCreateDtoToJSON(requestParameters['iFeeReversalCreateDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reverse fee
     */
    async feeReversal(requestParameters: FeeReversalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.feeReversalRaw(requestParameters, initOverrides);
    }

    /**
     * Transfer fee
     */
    async feeTransferRaw(requestParameters: FeeTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iFeeTransferCreateDto'] == null) {
            throw new runtime.RequiredError(
                'iFeeTransferCreateDto',
                'Required parameter "iFeeTransferCreateDto" was null or undefined when calling feeTransfer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/fee/transfer`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IFeeTransferCreateDtoToJSON(requestParameters['iFeeTransferCreateDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Transfer fee
     */
    async feeTransfer(requestParameters: FeeTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.feeTransferRaw(requestParameters, initOverrides);
    }

    /**
     * Find transactions by types and account ID
     */
    async findTransactionsRaw(requestParameters: FindTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageTransactionDto>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling findTransactions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['account_id'] = requestParameters['accountId'];
        }

        if (requestParameters['types'] != null) {
            queryParameters['types'] = requestParameters['types'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/transactions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageTransactionDtoFromJSON(jsonValue));
    }

    /**
     * Find transactions by types and account ID
     */
    async findTransactions(requestParameters: FindTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageTransactionDto> {
        const response = await this.findTransactionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get existing account by id
     */
    async getAccountRaw(requestParameters: GetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEncryptedAccountDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEncryptedAccountDtoFromJSON(jsonValue));
    }

    /**
     * Get existing account by id
     */
    async getAccount(requestParameters: GetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEncryptedAccountDto> {
        const response = await this.getAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get account activities transaction types by account
     */
    async getAccountActivityTransactionTypesRaw(requestParameters: GetAccountActivityTransactionTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Set<string>>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getAccountActivityTransactionTypes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/activities/accounts/{account-id}/transaction-types`;
        urlPath = urlPath.replace(`{${"account-id"}}`, encodeURIComponent(String(requestParameters['accountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get account activities transaction types by account
     */
    async getAccountActivityTransactionTypes(requestParameters: GetAccountActivityTransactionTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Set<string>> {
        const response = await this.getAccountActivityTransactionTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get existing accounts by ids
     */
    async getAccountBatchRaw(requestParameters: GetAccountBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEncryptedAccountDto>>> {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError(
                'ids',
                'Required parameter "ids" was null or undefined when calling getAccountBatch().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts/batch`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IEncryptedAccountDtoFromJSON));
    }

    /**
     * Get existing accounts by ids
     */
    async getAccountBatch(requestParameters: GetAccountBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEncryptedAccountDto>> {
        const response = await this.getAccountBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all existing account categories
     */
    async getAccountCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAccountCategoryDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/enums/account-categories`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IAccountCategoryDtoFromJSON));
    }

    /**
     * Get all existing account categories
     */
    async getAccountCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAccountCategoryDto>> {
        const response = await this.getAccountCategoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get account closure amounts
     */
    async getAccountClosureAmountsRaw(requestParameters: GetAccountClosureAmountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAccountClosureAmountsDto>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getAccountClosureAmounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['account_id'] = requestParameters['accountId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts/closure-amounts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAccountClosureAmountsDtoFromJSON(jsonValue));
    }

    /**
     * Get account closure amounts
     */
    async getAccountClosureAmounts(requestParameters: GetAccountClosureAmountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAccountClosureAmountsDto> {
        const response = await this.getAccountClosureAmountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all existing AccountTypes
     */
    async getAccountTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAccountTypeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/enums/account-types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IAccountTypeDtoFromJSON));
    }

    /**
     * Get all existing AccountTypes
     */
    async getAccountTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAccountTypeDto>> {
        const response = await this.getAccountTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all existing accounts
     */
    async getAccountsRaw(requestParameters: GetAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageEncryptedAccountDto>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['statusType'] != null) {
            queryParameters['status_type'] = requestParameters['statusType'];
        }

        if (requestParameters['externalIdentifier'] != null) {
            queryParameters['external_identifier'] = requestParameters['externalIdentifier'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICustomPageEncryptedAccountDtoFromJSON(jsonValue));
    }

    /**
     * Get all existing accounts
     */
    async getAccounts(requestParameters: GetAccountsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageEncryptedAccountDto> {
        const response = await this.getAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all accounts with verification status by search params
     */
    async getAccountsWithVerificationStatusRaw(requestParameters: GetAccountsWithVerificationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAccountVerificationStatusResponseDto>>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getAccountsWithVerificationStatus().'
            );
        }

        if (requestParameters['accountType'] == null) {
            throw new runtime.RequiredError(
                'accountType',
                'Required parameter "accountType" was null or undefined when calling getAccountsWithVerificationStatus().'
            );
        }

        if (requestParameters['accountStatusTypes'] == null) {
            throw new runtime.RequiredError(
                'accountStatusTypes',
                'Required parameter "accountStatusTypes" was null or undefined when calling getAccountsWithVerificationStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['accountType'] != null) {
            queryParameters['account_type'] = requestParameters['accountType'];
        }

        if (requestParameters['accountStatusTypes'] != null) {
            queryParameters['account_status_types'] = requestParameters['accountStatusTypes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts/verification`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IAccountVerificationStatusResponseDtoFromJSON));
    }

    /**
     * Get all accounts with verification status by search params
     */
    async getAccountsWithVerificationStatus(requestParameters: GetAccountsWithVerificationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAccountVerificationStatusResponseDto>> {
        const response = await this.getAccountsWithVerificationStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Decrypt account number last 4 digits
     */
    async getDecryptedAccountNumberRaw(requestParameters: GetDecryptedAccountNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling getDecryptedAccountNumber().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts/number/last4/decrypt`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Decrypt account number last 4 digits
     */
    async getDecryptedAccountNumber(requestParameters: GetDecryptedAccountNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getDecryptedAccountNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get decrypted account number
     */
    async getDecryptedAccountNumberByAccountIdRaw(requestParameters: GetDecryptedAccountNumberByAccountIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getDecryptedAccountNumberByAccountId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts/{account-id}/number/decrypted`;
        urlPath = urlPath.replace(`{${"account-id"}}`, encodeURIComponent(String(requestParameters['accountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get decrypted account number
     */
    async getDecryptedAccountNumberByAccountId(requestParameters: GetDecryptedAccountNumberByAccountIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getDecryptedAccountNumberByAccountIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all existing EXTERNAL accounts by organizationId
     */
    async getExternalAccountsByOrganizationRaw(requestParameters: GetExternalAccountsByOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageEncryptedAccountDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getExternalAccountsByOrganization().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/{organization-id}/accounts`;
        urlPath = urlPath.replace(`{${"organization-id"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICustomPageEncryptedAccountDtoFromJSON(jsonValue));
    }

    /**
     * Get all existing EXTERNAL accounts by organizationId
     */
    async getExternalAccountsByOrganization(requestParameters: GetExternalAccountsByOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageEncryptedAccountDto> {
        const response = await this.getExternalAccountsByOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get HSA account number & routing transit number by account_id
     */
    async getHsaAccountNumberRaw(requestParameters: GetHsaAccountNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAccountNumberDto>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getHsaAccountNumber().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts/hsa/{account-id}/number`;
        urlPath = urlPath.replace(`{${"account-id"}}`, encodeURIComponent(String(requestParameters['accountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAccountNumberDtoFromJSON(jsonValue));
    }

    /**
     * Get HSA account number & routing transit number by account_id
     */
    async getHsaAccountNumber(requestParameters: GetHsaAccountNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAccountNumberDto> {
        const response = await this.getHsaAccountNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get accounts by employee
     */
    async getHsaAccountsByEmployeeIdsRaw(requestParameters: GetHsaAccountsByEmployeeIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAccountDto>>> {
        if (requestParameters['employeeIds'] == null) {
            throw new runtime.RequiredError(
                'employeeIds',
                'Required parameter "employeeIds" was null or undefined when calling getHsaAccountsByEmployeeIds().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeIds'] != null) {
            queryParameters['employee_ids'] = requestParameters['employeeIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts/hsa`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IAccountDtoFromJSON));
    }

    /**
     * Get accounts by employee
     */
    async getHsaAccountsByEmployeeIds(requestParameters: GetHsaAccountsByEmployeeIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAccountDto>> {
        const response = await this.getHsaAccountsByEmployeeIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find HSA accounts that contains search value in the fields: account number
     */
    async getHsaAccountsBySearchValueRaw(requestParameters: GetHsaAccountsBySearchValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageAccountDto>> {
        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts/matches`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICustomPageAccountDtoFromJSON(jsonValue));
    }

    /**
     * Find HSA accounts that contains search value in the fields: account number
     */
    async getHsaAccountsBySearchValue(requestParameters: GetHsaAccountsBySearchValueRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageAccountDto> {
        const response = await this.getHsaAccountsBySearchValueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get internal account number by account_id
     */
    async getInternalAccountNumberRaw(requestParameters: GetInternalAccountNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getInternalAccountNumber().'
            );
        }

        if (requestParameters['accountType'] == null) {
            throw new runtime.RequiredError(
                'accountType',
                'Required parameter "accountType" was null or undefined when calling getInternalAccountNumber().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountType'] != null) {
            queryParameters['account_type'] = requestParameters['accountType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts/internal/{account-id}/number`;
        urlPath = urlPath.replace(`{${"account-id"}}`, encodeURIComponent(String(requestParameters['accountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get internal account number by account_id
     */
    async getInternalAccountNumber(requestParameters: GetInternalAccountNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getInternalAccountNumberRaw(requestParameters, initOverrides);
    }

    /**
     * Get plan Omni balance history for account by date range
     */
    async getPlanOmniBalanceHistory1Raw(requestParameters: GetPlanOmniBalanceHistory1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanOmniBalanceHistoryDto>>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getPlanOmniBalanceHistory1().'
            );
        }

        if (requestParameters['startDay'] == null) {
            throw new runtime.RequiredError(
                'startDay',
                'Required parameter "startDay" was null or undefined when calling getPlanOmniBalanceHistory1().'
            );
        }

        if (requestParameters['endDay'] == null) {
            throw new runtime.RequiredError(
                'endDay',
                'Required parameter "endDay" was null or undefined when calling getPlanOmniBalanceHistory1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['account_id'] = requestParameters['accountId'];
        }

        if (requestParameters['startDay'] != null) {
            queryParameters['start_day'] = (requestParameters['startDay'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['endDay'] != null) {
            queryParameters['end_day'] = (requestParameters['endDay'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/plan-omni-balances/history`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPlanOmniBalanceHistoryDtoFromJSON));
    }

    /**
     * Get plan Omni balance history for account by date range
     */
    async getPlanOmniBalanceHistory1(requestParameters: GetPlanOmniBalanceHistory1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanOmniBalanceHistoryDto>> {
        const response = await this.getPlanOmniBalanceHistory1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get public key for encryption
     */
    async getPublicKeyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPublicKeyDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/encryption/public-key`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPublicKeyDtoFromJSON(jsonValue));
    }

    /**
     * Get public key for encryption
     */
    async getPublicKey(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPublicKeyDto> {
        const response = await this.getPublicKeyRaw(initOverrides);
        return await response.value();
    }

    /**
     * Trigger balance adjustment workflow
     */
    async triggerBalanceAdjustmentWorkflow1Raw(requestParameters: TriggerBalanceAdjustmentWorkflow1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IBalanceAdjustmentTrackingResponseDto>> {
        if (requestParameters['iBalanceAdjustmentRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iBalanceAdjustmentRequestDto',
                'Required parameter "iBalanceAdjustmentRequestDto" was null or undefined when calling triggerBalanceAdjustmentWorkflow1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/balance-adjustment`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IBalanceAdjustmentRequestDtoToJSON(requestParameters['iBalanceAdjustmentRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IBalanceAdjustmentTrackingResponseDtoFromJSON(jsonValue));
    }

    /**
     * Trigger balance adjustment workflow
     */
    async triggerBalanceAdjustmentWorkflow1(requestParameters: TriggerBalanceAdjustmentWorkflow1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IBalanceAdjustmentTrackingResponseDto> {
        const response = await this.triggerBalanceAdjustmentWorkflow1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update account by id
     */
    async updateAccountRaw(requestParameters: UpdateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEncryptedAccountDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAccount().'
            );
        }

        if (requestParameters['iUpdateEncryptedExternalBankAccountDto'] == null) {
            throw new runtime.RequiredError(
                'iUpdateEncryptedExternalBankAccountDto',
                'Required parameter "iUpdateEncryptedExternalBankAccountDto" was null or undefined when calling updateAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IUpdateEncryptedExternalBankAccountDtoToJSON(requestParameters['iUpdateEncryptedExternalBankAccountDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEncryptedAccountDtoFromJSON(jsonValue));
    }

    /**
     * Update account by id
     */
    async updateAccount(requestParameters: UpdateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEncryptedAccountDto> {
        const response = await this.updateAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum FindTransactionsTypesEnum {
    NOTIONAL_FUND = 'NOTIONAL_FUND',
    REPLENISHMENT_PAYMENT = 'REPLENISHMENT_PAYMENT',
    REPLENISHMENT = 'REPLENISHMENT',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    CARD_SETTLEMENT = 'CARD_SETTLEMENT',
    PAY_CLAIM = 'PAY_CLAIM',
    CHECK_CLEARED = 'CHECK_CLEARED',
    CARD_PROCESSOR_PAYMENT = 'CARD_PROCESSOR_PAYMENT',
    RECORD_KEEPING_PAYROLL = 'RECORD_KEEPING_PAYROLL',
    CONTRIBUTION_PAYMENT = 'CONTRIBUTION_PAYMENT',
    PAYROLL = 'PAYROLL',
    EMPLOYER_PAYMENT = 'EMPLOYER_PAYMENT',
    PAYMENT = 'PAYMENT',
    INTEREST = 'INTEREST',
    FEE = 'FEE',
    TRANSFER_OF_ASSETS = 'TRANSFER_OF_ASSETS',
    INVESTMENT = 'INVESTMENT',
    ACH_CLEARED = 'ACH_CLEARED',
    DEBIT_CLEARED = 'DEBIT_CLEARED',
    VENMO_CLEARED = 'VENMO_CLEARED',
    PAYPAL_CLEARED = 'PAYPAL_CLEARED',
    ADJUSTMENT = 'ADJUSTMENT',
    INTEREST_PAYMENT = 'INTEREST_PAYMENT',
    BUY_INVESTMENT = 'BUY_INVESTMENT',
    SELL_INVESTMENT = 'SELL_INVESTMENT',
    BUY_INVESTMENT_CLEARED = 'BUY_INVESTMENT_CLEARED',
    SELL_INVESTMENT_CLEARED = 'SELL_INVESTMENT_CLEARED',
    CLAIM_REPAYMENT = 'CLAIM_REPAYMENT',
    LOCKBOX_PAYMENT = 'LOCKBOX_PAYMENT',
    PAYMENT_CARD_RETURN = 'PAYMENT_CARD_RETURN',
    ROLLOVER = 'ROLLOVER',
    DIGITAL_SETTLEMENT = 'DIGITAL_SETTLEMENT',
    DEBIT_VENMO_PAYPAL_REJECTED = 'DEBIT_VENMO_PAYPAL_REJECTED',
    RETURN_REPLENISHMENT_PAYMENT = 'RETURN_REPLENISHMENT_PAYMENT',
    RECORD_KEEPING = 'RECORD_KEEPING',
    CONTRIBUTION_PAID = 'CONTRIBUTION_PAID',
    PREFUND_REPLENISHMENT = 'PREFUND_REPLENISHMENT',
    INTERNAL_TRANSFER_OF_ASSETS = 'INTERNAL_TRANSFER_OF_ASSETS',
    HSA_INCOMING_CONTRIBUTION = 'HSA_INCOMING_CONTRIBUTION',
    HSA_ROLLOVER = 'HSA_ROLLOVER',
    ORPHAN_EE_FEE = 'ORPHAN_EE_FEE',
    ORPHAN_EE_FEE_PAYMENT = 'ORPHAN_EE_FEE_PAYMENT',
    ADMIN_FEE = 'ADMIN_FEE',
    ADMIN_FEE_PAYMENT = 'ADMIN_FEE_PAYMENT',
    REPLENISHMENT_REVERSE = 'REPLENISHMENT_REVERSE',
    ACH_REJECTED = 'ACH_REJECTED',
    RETURN_CONTRIBUTION_PAYMENT = 'RETURN_CONTRIBUTION_PAYMENT',
    HSA_INCOMING_CONTRIBUTION_REVERSE = 'HSA_INCOMING_CONTRIBUTION_REVERSE',
    HSA_ROLLOVER_REVERSE = 'HSA_ROLLOVER_REVERSE',
    INVESTMENT_FEES = 'INVESTMENT_FEES',
    REPLENISHMENT_FUNDING_REVERSE = 'REPLENISHMENT_FUNDING_REVERSE',
    RETURN_REPLENISHMENT_FUNDING_PAYMENT = 'RETURN_REPLENISHMENT_FUNDING_PAYMENT',
    CLAIM_TRANSFER = 'CLAIM_TRANSFER',
    CLAIM_TRANSFER_INTERNAL = 'CLAIM_TRANSFER_INTERNAL',
    PAYROLL_REVERSE = 'PAYROLL_REVERSE',
    CONTRIBUTION_PAID_REVERSE = 'CONTRIBUTION_PAID_REVERSE',
    CONTRIBUTION_REVERSE_PAYMENT = 'CONTRIBUTION_REVERSE_PAYMENT',
    PREFUND_REPLENISHMENT_RETURN = 'PREFUND_REPLENISHMENT_RETURN',
    FINAL_PREFUND_REPLENISHMENT_RETURN = 'FINAL_PREFUND_REPLENISHMENT_RETURN',
    PREFUND_PAYMENT = 'PREFUND_PAYMENT',
    PREFUND_INTER = 'PREFUND_INTER',
    RETURN_PREFUND_FUNDING_PAYMENT = 'RETURN_PREFUND_FUNDING_PAYMENT',
    PREFUND_FINAL = 'PREFUND_FINAL',
    PREFUND_FUNDING_REVERSE = 'PREFUND_FUNDING_REVERSE',
    RETURN_LOCKBOX = 'RETURN_LOCKBOX',
    INBOUND_CHECK_CLEARED = 'INBOUND_CHECK_CLEARED',
    LOCKBOX_INCOMING = 'LOCKBOX_INCOMING',
    INBOUND_TRANSFER_OF_ASSETS = 'INBOUND_TRANSFER_OF_ASSETS',
    OUTBOUND_TRANSFER_OF_ASSETS = 'OUTBOUND_TRANSFER_OF_ASSETS',
    OUTBOUND_CHECK_CLEARED = 'OUTBOUND_CHECK_CLEARED',
    CLAIM_OFFSET = 'CLAIM_OFFSET',
    WRITE_OFF = 'WRITE_OFF',
    FORFEITURE = 'FORFEITURE',
    PUSH_REPLENISHMENT_PAYMENT = 'PUSH_REPLENISHMENT_PAYMENT',
    PUSH_PREFUND_PAYMENT = 'PUSH_PREFUND_PAYMENT',
    PUSH_CONTRIBUTION_PAYMENT = 'PUSH_CONTRIBUTION_PAYMENT',
    PAYMENT_EE_FEE = 'PAYMENT_EE_FEE',
    ACCOUNT_MAINTENANCE_EE_FEE = 'ACCOUNT_MAINTENANCE_EE_FEE',
    PAPER_STATEMENT_EE_FEE = 'PAPER_STATEMENT_EE_FEE',
    EE_FEES_BULK_PAYMENT = 'EE_FEES_BULK_PAYMENT',
    OTHER_ROOT_INTERNAL_TRANSFER_OF_ASSETS = 'OTHER_ROOT_INTERNAL_TRANSFER_OF_ASSETS',
    FEE_TRANSFER_INTERNAL = 'FEE_TRANSFER_INTERNAL',
    FEE_TRANSFER = 'FEE_TRANSFER',
    CLAIM_REJECTION = 'CLAIM_REJECTION',
    ACH_CLAIM_REPAYMENT = 'ACH_CLAIM_REPAYMENT',
    ACH_CLAIM_REPAYMENT_REJECTED = 'ACH_CLAIM_REPAYMENT_REJECTED',
    CLAIM_REPAYMENT_REJECTION = 'CLAIM_REPAYMENT_REJECTION',
    CLAIM_REPAYMENT_TRANSFER_INTERNAL = 'CLAIM_REPAYMENT_TRANSFER_INTERNAL',
    CLAIM_REPAYMENT_TRANSFER = 'CLAIM_REPAYMENT_TRANSFER',
    LOCKBOX_CHECK_CLEARED = 'LOCKBOX_CHECK_CLEARED',
    LOCKBOX_CLAIM_REPAYMENT = 'LOCKBOX_CLAIM_REPAYMENT',
    NOTIONAL_CONTRIBUTION_PAID = 'NOTIONAL_CONTRIBUTION_PAID',
    PREFUND_RETURN_PAYMENT_REVERSE = 'PREFUND_RETURN_PAYMENT_REVERSE',
    CLAIM_BALANCE_ADJUSTMENT = 'CLAIM_BALANCE_ADJUSTMENT',
    NOTIONAL_CONTRIBUTION_PAID_REVERSE = 'NOTIONAL_CONTRIBUTION_PAID_REVERSE',
    ROLLOVER_BALANCE_ADJUSTMENT = 'ROLLOVER_BALANCE_ADJUSTMENT',
    EOY_PLAN_FUNDS_INTERNAL_RETURN = 'EOY_PLAN_FUNDS_INTERNAL_RETURN',
    PUSH_RETURN_PAYMENT = 'PUSH_RETURN_PAYMENT',
    HSA_INCOMING_CONTRIBUTION_PAYMENT = 'HSA_INCOMING_CONTRIBUTION_PAYMENT',
    NOTIONAL_PAYROLL_REVERSE = 'NOTIONAL_PAYROLL_REVERSE',
    EOY_PLAN_FUNDS_INTERNAL_RETURN_PAYMENT = 'EOY_PLAN_FUNDS_INTERNAL_RETURN_PAYMENT',
    EOY_PLAN_FUNDS_EXTERNAL_RETURN = 'EOY_PLAN_FUNDS_EXTERNAL_RETURN',
    EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT = 'EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT',
    EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT_REVERSE = 'EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT_REVERSE',
    EOY_PLAN_SHORTAGE_COLLECTION = 'EOY_PLAN_SHORTAGE_COLLECTION',
    EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT = 'EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT',
    EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT_REVERSE = 'EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT_REVERSE',
    EOY_PLAN_SHORTAGE_COLLECTION_PUSH_PAYMENT = 'EOY_PLAN_SHORTAGE_COLLECTION_PUSH_PAYMENT',
    PUSH_UNKNOWN_PAYMENT = 'PUSH_UNKNOWN_PAYMENT',
    UNMATCHED_PUSH_KEEPING = 'UNMATCHED_PUSH_KEEPING',
    PUSH_INVOICE_PAYMENT = 'PUSH_INVOICE_PAYMENT',
    UNMATCHED_PUSH_RETURN = 'UNMATCHED_PUSH_RETURN',
    CLAIM_BALANCE_ADJUSTMENT_EXTERNAL = 'CLAIM_BALANCE_ADJUSTMENT_EXTERNAL',
    ROLLOVER_BALANCE_ADJUSTMENT_CROSS_OMNIBUS = 'ROLLOVER_BALANCE_ADJUSTMENT_CROSS_OMNIBUS',
    ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL = 'ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL',
    BULK_BALANCE_ADJUSTMENT = 'BULK_BALANCE_ADJUSTMENT',
    BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT = 'BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT',
    BULK_BALANCE_ADJUSTMENT_PUSH_PAYMENT = 'BULK_BALANCE_ADJUSTMENT_PUSH_PAYMENT',
    BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT_REVERSE = 'BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT_REVERSE',
    BULK_BALANCE_ADJUSTMENT_REVERSE = 'BULK_BALANCE_ADJUSTMENT_REVERSE',
    CLAIM_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE = 'CLAIM_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE',
    ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE = 'ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE',
    BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT = 'BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT',
    BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT_REVERSE = 'BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT_REVERSE'
}
/**
  * @export
  * @enum {string}
  */
export enum GetAccountsTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
  * @export
  * @enum {string}
  */
export enum GetAccountsStatusTypeEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    PENDING = 'PENDING'
}
/**
  * @export
  * @enum {string}
  */
export enum GetAccountsWithVerificationStatusAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
  * @export
  * @enum {string}
  */
export enum GetAccountsWithVerificationStatusAccountStatusTypesEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    PENDING = 'PENDING'
}
/**
  * @export
  * @enum {string}
  */
export enum GetInternalAccountNumberAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
